(function() { module.exports = window[undefined]; }());